import { can, PortalPermissions } from "../../../../config/permissions";
import React from "react";
import { EditOutlined } from "@ant-design/icons";
import Table, { TableColumn } from "../../../../components/Table";
import { formatDateView } from "../../../../utils/formatViews";
import { ConfigurationsTableProps, NpsConfiguration } from "../../types";
import { StatusBadge } from "../../styles";

const ConfigurationsTable: React.FC<ConfigurationsTableProps> = ({
  records,
  onEdit,
}) => (
  <Table
    dataSource={records.map((record) => ({ ...record, key: record.id }))}
    pagination={{
      showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} pesquisas`,
    }}
  >
    <TableColumn title="Pergunta" dataIndex="question" key="question" ellipsis />
    <TableColumn title="Início da campanha" dataIndex="validFrom" key="validFrom" render={formatDateView} />
    <TableColumn title="Fim da campanha" dataIndex="validTo" key="validTo" render={formatDateView} />
    <TableColumn title="Reexibição (horas)" dataIndex="redisplayHours" key="redisplayHours" align="center" />
    <TableColumn title="Atualizada em" dataIndex="updatedAt" key="updatedAt" render={formatDateView} />
    <TableColumn
      title="Status"
      dataIndex="isActive"
      key="isActive"
      align="center"
      render={(isActive: boolean) => (
        <StatusBadge $active={isActive}>{isActive ? "Ativa" : "Inativa"}</StatusBadge>
      )}
    />
    <TableColumn
      title="Editar"
      key="edit"
      align="center"
      render={(_, record) => (
        can(PortalPermissions.administracao.pesquisaNps.editar) ? (
          <EditOutlined
            style={{ cursor: "pointer", fontSize: 18, color: "#faad14" }}
            onClick={() => onEdit(record as NpsConfiguration)}
          />
        ) : null
      )}
    />
  </Table>
);

export default ConfigurationsTable;
